import React from 'react'
import { BaseComponent, DonutChart } from 'belle-js'

import DonutTooltip from './DonutTooltip/DonutTooltip'
import { allClassAllocations, formatClassName } from 'utils/Client/classAllocationsConfig.js'
import Big from 'big.js'

import styles from './PortfolioDonut.module.scss'

class PortfolioDonut extends BaseComponent {

  constructor (props) {
    super(props)
    this.state = {
      activeXPos: 0,
      activeYPos: 0,
      classAllocation: {},
      showTooltip: false,
    }
    this.handleHover = this.handleHover.bind(this)
  }

  mapModel (model) {
    return model.map((classAllocation, i) => {
      const assetConfig = allClassAllocations.find(
        a => a.name === formatClassName(classAllocation.className)
      )
      const donutValue = parseInt(new Big(classAllocation.percentage).toString(), 10)

      return {
        order: i,
        fill: assetConfig.color,
        key: assetConfig.key,
        name: assetConfig.name,
        type: assetConfig.type,
        pattern: !!model.impactFunds,
        value: donutValue,
        totalEmv: classAllocation.totalEmv,
      }
    })
  }

  checkPercentages (model) {
    return model.every(classAllocation => (classAllocation.percentage != null))
  }

  handleHover (data, [mouseX, mouseY]) {
    let newState = {
      showTooltip: false,
    }

    if ((mouseX || mouseX === 0) && (mouseY || mouseY === 0)) {
      newState = {
        activeXPos: mouseX + 60,
        activeYPos: mouseY + 10,
        classAllocation: data.data,
        showTooltip: true,
      }
    }
    this.setState(newState)
  }

  render () {
    const {
      classAllocation,
      showTooltip,
      activeXPos,
      activeYPos,
    } = this.state
    const {
      model,
      width,
      height,
      innerRadius,
    } = this.props

    const hasPercentages = this.checkPercentages(model)
    const modelData =  hasPercentages && this.mapModel(model)

    const tooltipStyles = {
      left: `${activeXPos}px`,
      top: `${activeYPos}px`,
    }

    return hasPercentages && (
      <div className={styles.PortfolioDonut} data-test-id="donutChartTestId">
        <DonutChart
          width={width}
          height={height}
          innerRadius={innerRadius}
          data={modelData}
          showHover={true}
          onHover={this.handleHover} />
        <DonutTooltip
          classAllocation={classAllocation}
          tooltipStyles={tooltipStyles}
          showTooltip={showTooltip} />
      </div>
    )
  }

}

export default PortfolioDonut



// WEBPACK FOOTER //
// ./src/components/Client/PortfolioDonut/PortfolioDonut.jsx